import { render, staticRenderFns } from "./vehicle-info-groups.vue?vue&type=template&id=58e4b209"
import script from "./vehicle-info-groups.vue?vue&type=script&lang=js"
export * from "./vehicle-info-groups.vue?vue&type=script&lang=js"
import style0 from "./vehicle-info-groups.vue?vue&type=style&index=0&id=58e4b209&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports